import { FC, useState } from 'react';
import { Popover } from 'antd';
import { Link } from '@base/lib/Link';
import { RouteEnum } from 'pro/config/routers';
import { CATEGORIES } from 'pro/config/categories';
import { TiledTree } from '@base/lib/TiledTree';
import { HtmlRender } from '@base/snippets/HtmlRender';
import styles from './index.module.less';

export const Products: FC = () => {
    const [visible, setVisible] = useState<boolean>(false);

    const onClose = () => setVisible(false);

    return (
        <Popover
            overlayClassName={styles.popover}
            open={visible}
            onOpenChange={setVisible}
            placement="bottom"
            showArrow={false}
            align={{ offset: [0, 0] }}
            content={
                <TiledTree
                    className={styles.nav}
                    list={CATEGORIES.map(cat => ({
                        key: cat.key,
                        title: <HtmlRender html={cat.name}/>,
                        url: cat.url,
                        children: (cat.children || []).map(item => ({
                            key: item.key,
                            title: `${item.serie}`,
                            url: item.url
                        }))
                    }))}
                    onLinkClick={onClose}
                />
            }
        >
            <Link
                href={RouteEnum.PRODUCTS}
                className={styles['nav-link1']}
                onClick={onClose}
            >
                Products
            </Link>
        </Popover>
    )
};
